var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',{attrs:{"name":"fade"}},[(_setup.loadingBar)?_c('div',{staticClass:"fixed top-0 left-0 h-1 w-full overflow-hidden bg-microsoft-blue-default/20 z-[1000]"},[_c('div',{staticClass:"progress-bar-value w-full h-full bg-microsoft-blue-default"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }